module.exports = require("@bechtel/client-assets/dist/images/crew-change.svg");